import React, { useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import './App.scss';
import Aos from "aos";
import 'aos/dist/aos.css';
import "./assets/css/remixicon.css"
import Home from './View/Home/home';
import Footer from './View/_Common/Footer';
import ScrollToTop from './View/_Common/ScrollToTop';
import PrivacyPolicy from './View/QuickLinks/privacy-policy';
import TermsofUse from './View/QuickLinks/terms-of-use';
import SafetyGuidelines from './View/QuickLinks/safety-guidelines';
import FullFleet from './View/FullFleet/full-fleet';
import FleetDetail from './View/FleetDetail/fleet-detail';

export default function App() {
  // ✅ Initialize AOS only once when the app loads
  useEffect(() => {
    Aos.init({
      duration: 700,
      easing: "ease-out-cubic",
      offset: 60,
      once: true,
      mirror: false,
    });
  }, []);

  return (
    <React.Fragment>
      <ScrollToTop />
      <div className="main-app">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/home" element={<Home />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-use" element={<TermsofUse />} />
          <Route path="/safety-guidelines" element={<SafetyGuidelines />} />
          <Route path="/full-fleet" element={<FullFleet />} />
          <Route path="/fleet-detail/:slug" element={<FleetDetail />} />
        </Routes>
      </div>
      <Footer />
    </React.Fragment>
  );
}
